import React, { useMemo, useState } from "react";
import "./UGCPublicSelfDisclosure.css";
import Backtotop from "../../widgets/Backtotop/Backtotop";
/*
 * ACGCET - UGC Public Self-Disclosure
 * Suggested route: /ugc-public-self-disclosure
 *
 * Uses existing ACGCET information and verified internal URLs.
 * Items without a verified existing page are shown as "To be updated".
 * Verified informational content can be expanded inline without a link.
 *
 * The Contact Us section uses the existing ACGCET footer information:
 * - Address
 * - 04565 224528
 * - 224535
 * - accetprincipal@gmail.com
 *
 * About Us: Overview is rendered as expandable inline content.
 */

const departmentLinks = [
  ["Civil Engineering", "/civildept"],
  ["Mechanical Engineering", "/mechdept"],
  ["Electrical and Electronics Engineering", "/eeedept"],
  ["Electronics and Communication Engineering", "/ecedept"],
  ["Computer Science and Engineering", "/csedept"],
  ["Information Technology", "/itdept"],
  ["Physics", "/Physicsdept"],
  ["Chemistry", "/Chemistrydept"],
  ["Mathematics", "/Mathsdept"],
  ["English", "/Englishdept"],
];

const sections = [
  {
    id: "about-hei",
    title: "A. About HEI",
   
    items: [
      {
       // type: "content",
        label: "About Us: Overview",
         href:"/about-institution",
        // content: [
        //   // "National Education Policy (NEP) 2020 emphasizes transparent self-disclosure by Higher Education Institutions (HEIs). Public self-disclosure by HEIs is one of the fundamental principles of the policy. NEP contemplates that HEIs shall be responsible and accountable to stakeholders through transparent self-disclosure of all relevant records.",
        //   // "The availability of information in the public domain is an important source of accountability.",
        //   // "Stakeholders in the higher education system, such as students, parents, research scholars, prospective students, regulatory bodies, accreditation agencies, alumni, and the public, seek information from the websites of HEIs.",
        //   // "Every Higher Education Institution shall maintain a functional website for making relevant self-disclosure to stakeholders. The disclosure made on the website shall have unrestricted access without any requirement of login or registration and shall have a Search facility for easy access.",
        //   // "Higher Education Institutions may provide relevant information on their websites and provide links wherever possible."

        // ]
      },
      { label: "Act and Statutes / MoA", href: "/Coe_mou" },
      // { label: "Institutional Development Plan", unavailable: true },
      // {
      //   label: "Constituent Units / Affiliated Colleges / Affiliating University",
      //   unavailable: true,
      // },
      // {
      //   label:
      //     "Off-campus / Off-shore Campus / Learning Support Centres, where applicable",
      //   unavailable: true,
      // },
      { label: "Accreditation / Ranking — NAAC", href: "/naac" },
      { label: "Accreditation / Ranking — NBA", href: "/nba" },
      { label: "Accreditation / Ranking — NIRF", href: "/nirf" },
      // {
      //   label: "Recognition / Approval — 2(f), 12B, etc.",
      //   unavailable: true,
      // },
      { label: "Annual Reports", href: "/annual_reports" },
      // {
      //   label:
      //     "Annual Accounts including Balance Sheet, Income & Expenditure Account, Receipts & Payments Account and Audit Report",
      //   unavailable: true,
      // },
      // {
      //   label: "Sponsoring Body Details, if applicable",
      //   unavailable: true,
      // },
    ],
  },

  {
    id: "administration",
    title: "B. Administration",
    items: [
      // { label: "Chancellor", unavailable: true },
      // { label: "Pro Chancellor", unavailable: true },
      // { label: "Vice-Chancellor", unavailable: true },
      // {
      //   label: "Pro-Vice-Chancellor, where applicable",
      //   unavailable: true,
      // },
      // { label: "Registrar", unavailable: true },
      { label: "Principal", href: "/office" },
      // { label: "Finance Officer", unavailable: true },
      { label: "Controller of Examination", href: "/coe" },
      // { label: "Chief Vigilance Officer", unavailable: true },
      // { label: "Ombudsperson", unavailable: true },
      {
        label: "Executive Council / Board of Governors",
        href: "/BoG",
      },
      // { label: "Board of Management", unavailable: true },
      // { label: "Academic Council", unavailable: true },
      // { label: "Board of Studies", unavailable: true },
      // { label: "Finance Committee", unavailable: true },
      {
        label: "Internal Complaints Committee",
        href: "/committee",
      },
      {
        label: "Academic Leadership / HoDs",
        href: "/organisation",
      },
      {
        label: "Administration / Office",
        href: "/office",
      },
      {
        label: "Institutional Committees",
        href: "/committee",
      },
    ],
  },

  {
    id: "academics",
    title: "C. Academics",
    items: [
      {
        label: "Details of Academic Programs",
        href: "/programs",
      },
      {
        label: "Academic Calendar",
        href: "/academic-calendar",
      },
      // {
      //   label:
      //     "Statutes / Ordinances pertaining to Academics / Examinations",
      //   unavailable: true,
      // },
      {
        label: "Departments ",
        children: departmentLinks.map(([label, href]) => ({
          label,
          href,
        })),
      },
      // {
      //   label: "Department-wise Faculty / Staff",
      //   unavailable: true,
      // },
      // {
      //   label: "UGC-recognized ODL / Online Programs, if applicable",
      //   unavailable: true,
      // },
      {
        label: "Internal Quality Assurance Cell (IQAC)",
        href: "/iqac",
      },
      {
        label: "Library",
        href: "/library",
      },
      {
        label: "Academic Collaborations / MoUs",
        href: "/Coe_mou",
      },
    ],
  },

  {
    id: "admissions-fee",
    title: "D. Admissions & Fee",
    items: [
      {
        label: "Prospectus",
        href: "/fee-structure",
      },
      // {
      //   label: "Fee Structure",
      //   href: "/fee-structure",
      // },
      {
  label: "Admission Process and Guidelines",
  href: "https://www.tneaonline.org/",
  external: true,
  note: "Application can be submitted online through TNEA",
},
      // {
      //   label: "Fee Refund Policy",
      //   unavailable: true,
      // },
    ],
  },

  {
    id: "research",
    title: "E. Research",
    items: [
      {
        label: "Research & Development Cell",
        href: "/research",
      },
      // {
      //   label: "Research Projects",
      //   href: "/research",
      // },
      // {
      //   label: "Consultancy Projects",
      //   unavailable: true,
      // },
      // {
      //   label: "Foreign Collaborations",
      //   unavailable: true,
      // },
      // {
      //   label: "Industry Collaborations",
      //   unavailable: true,
      // },
      {
        label: "Incubation Centre / Startups / Entrepreneurship Cell",
        href: "/incubation",
      },
      {
        label: "Central Facilities",
        href: "/centers-and-facilities",
      },
    ],
  },

  {
    id: "student-life",
    title: "F. Student Life",
    items: [
      {
        label: "Sports Facilities",
        href: "/centers-and-facilities",
      },
      {
        label: "NCC / NSS",
        children: [
          {
            label: "NCC",
            href: "/ncc",
          },
          {
            label: "NSS",
            href: "/nss",
          },
        ],
      },
      {
        label: "Hostel Details",
        href: "/centers-and-facilities",
      },
      {
        label: "Placement Cell and Activities",
        href: "/placement",
      },
      {
        label: "Student Grievance Redressal Committee (SGRC) and Ombudsperson",
        href: "/committee",
      },
      
      // {
      //   label: "Health Facilities",
      //   href: "/centers-and-facilities",
      // },
      {
        label: "Internal Complaints Committee",
        href: "/committee",
      },
      {
        label: "Anti-Ragging Cell",
        href: "/committee",
      },
      // {
      //   label: "Equal Opportunity Cell",
      //   href: "/committee",
      // },
      // {
      //   label:
      //     "Socio-Economically Disadvantaged Groups Cell (SEDG)",
      //   unavailable: true,
      // },
      // {
      //   label:
      //     "Facilities for Differently-Abled Students / Barrier-Free Environment",
      //   href: "/centers-and-facilities",
      // },
    ],
  },

  {
    id: "alumni",
    title: "G. Alumni",
    items: [
      {
        label: "Alumni Association",
        href: "/alumni",
      },
    ],
  },

  {
    id: "information-corner",
    title: "H. Information Corner",
    items: [
      {
        label: "RTI / CPIO / Appellate Authority",
        href: "/rti",
      },
      {
        label: "Circulars & Notices",
        href: "/",
        note: "Bulletin Board on the ACGCET homepage",
      },
      {
        label: "Announcements",
        href: "/",
        note: "Bulletin Board on the ACGCET homepage",
      },
      // {
      //   label: "Newsletters",
      //   unavailable: true,
      // },
      {
        label: "News / Recent Events / Achievements",
        href: "/",
        note: "News and events on the ACGCET homepage",
      },
      {
        label: "Job Openings",
        href: "/",
        note:
          "Current notices are published on the ACGCET homepage Bulletin Board",
      },
      // {
      //   label: "Reservation Roster",
      //   unavailable: true,
      // },
      // {
      //   label: "Study in India",
      //   unavailable: true,
      // },
    ],
  },

  {
    id: "Picture Gallery",
    title: "I. Picture Gallery",
    items: [
      // {
      //   label: "International Student Admission Procedure",
      //   unavailable: true,
      // },
      // {
      //   label: "Facilities for International Students",
      //   unavailable: true,
      // },
      {
        label: "Picture Gallery ",
        href:"/iqac_programmes",
        external: true,
      },
    ],
  },

  {
    id: "contact-us",
    title: "J. Contact Us",
    items: [
      {
        label: "Phone Number — 04565 224528",
        href: "tel:+914565224528",
        external: true,
      },
      {
        label: "Phone Number — 224535",
        href: "tel:+914565224535",
        external: true,
      },
      {
        label: "Official Email ID — accetprincipal@gmail.com",
        href: "mailto:accetprincipal@gmail.com",
        external: true,
      },
      
      {
        label: "Location Map",
        href:"https://www.google.com/maps/place/Alagappa+Chettiar+Government+College+of+Engineering+%26+Technology./@10.089863,78.7939322,16.43z/data=!4m5!3m4!1s0x3b0067a028f8a8f9:0x9c2484c6df0fb26!8m2!3d10.090038!4d78.794712",
        external: true,
      },{
        type: "text",
        label:
          "Address — Alagappa Chettiar Government College of Engineering and Technology, Karaikudi-630003, Sivagangai, Tamilnadu.",
      },
      // {
      //   label: "Telephone Directory",
      //   unavailable: true,
      // },
    ],
  },
];

/* ---------- helpers ---------- */

function splitSectionTitle(title) {
  const i = title.indexOf(". ");

  if (i === -1) {
    return {
      letter: "",
      heading: title,
    };
  }

  return {
    letter: title.slice(0, i),
    heading: title.slice(i + 2),
  };
}

function countLeafItems(items) {
  return items.reduce(
    (total, item) =>
      total + (item.children ? countLeafItems(item.children) : 1),
    0
  );
}

function filterItems(items, query) {
  const needle = query.toLowerCase();

  return items.reduce((matches, item) => {
    if (item.children) {
      if (item.label.toLowerCase().includes(needle)) {
        matches.push(item);
        return matches;
      }

      const children = filterItems(item.children, query);

      if (children.length > 0) {
        matches.push({
          ...item,
          children,
        });
      }

      return matches;
    }

    if (item.label.toLowerCase().includes(needle)) {
      matches.push(item);
    }

    return matches;
  }, []);
}

/* ---------- icons ---------- */

function LinkIcon() {
  return (
    <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <path
        d="M7.5 12.5 12.5 7.5M8.5 6h4v4M15 11v3.5A1.5 1.5 0 0 1 13.5 16h-8A1.5 1.5 0 0 1 4 14.5v-8A1.5 1.5 0 0 1 5.5 5H9"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function PhoneIcon() {
  return (
    <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <path
        d="M6.2 4h2l1 3.2-1.6 1.2a9 9 0 0 0 4 4l1.2-1.6 3.2 1v2a1.4 1.4 0 0 1-1.5 1.4A12.6 12.6 0 0 1 4.8 5.5 1.4 1.4 0 0 1 6.2 4Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MailIcon() {
  return (
    <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <rect
        x="3.5"
        y="5"
        width="13"
        height="10"
        rx="1.4"
        stroke="currentColor"
        strokeWidth="1.4"
      />
      <path
        d="m4.5 6 5.5 4.5L15.5 6"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ChevronDownIcon() {
  return (
    <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <path
        d="m5 7.5 5 5 5-5"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ChevronRightIcon() {
  return (
    <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <path
        d="m7.5 5 5 5-5 5"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SearchIcon() {
  return (
    <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <circle
        cx="8.75"
        cy="8.75"
        r="5.25"
        stroke="currentColor"
        strokeWidth="1.4"
      />
      <path
        d="m16 16-3.4-3.4"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  );
}

function iconForItem(item) {
  if (item.href && item.href.startsWith("tel:")) {
    return <PhoneIcon />;
  }

  if (item.href && item.href.startsWith("mailto:")) {
    return <MailIcon />;
  }

  return <LinkIcon />;
}

/* ---------- item rendering ---------- */

function DisclosureItem({ item, nested = false }) {
  const [isContentOpen, setIsContentOpen] = useState(false);

  if (item.children) {
    return (
      <div
        className={`ugc-subgroup ${
          nested ? "ugc-subgroup--nested" : ""
        }`}
      >
        <div className="ugc-subgroup-title">
          {item.label}
        </div>

        <div className="ugc-child-list">
          {item.children.map((child) => (
            <DisclosureItem
              key={child.label}
              item={child}
              nested
            />
          ))}
        </div>
      </div>
    );
  }

  /*
   * Expandable verified content.
   * This is used for About Us: Overview and does not show
   * the "To be updated" status.
   */
  if (item.type === "content") {
    return (
      <div className="ugc-content-item">
        <button
          type="button"
          className="ugc-item ugc-item--content-trigger"
          aria-expanded={isContentOpen}
          onClick={() =>
            setIsContentOpen((current) => !current)
          }
        >
          <span
            className="ugc-item-icon"
            aria-hidden="true"
          >
            <LinkIcon />
          </span>

          <span className="ugc-item-content">
            <span className="ugc-item-label">
              {item.label}
            </span>
          </span>

          <span
            className={`ugc-item-arrow ${
              isContentOpen
                ? "ugc-item-arrow--open"
                : ""
            }`}
            aria-hidden="true"
          >
            <ChevronRightIcon />
          </span>
        </button>

        {isContentOpen && (
          <div className="ugc-content-panel">
            {item.content.map((paragraph, index) => (
              <p
                key={index}
                className="ugc-content-paragraph"
              >
                {paragraph}
              </p>
            ))}
          </div>
        )}
      </div>
    );
  }

  /*
   * Static verified information.
   * Unlike unavailable items, this does not show
   * "To be updated".
   */
  if (item.type === "text") {
    return (
      <div className="ugc-item ugc-item--static">
        <span
          className="ugc-item-icon"
          aria-hidden="true"
        >
          •
        </span>

        <span className="ugc-item-content">
          <span className="ugc-item-label">
            {item.label}
          </span>

          {item.note && (
            <span className="ugc-item-note">
              {item.note}
            </span>
          )}
        </span>
      </div>
    );
  }

  /*
   * Items that still need a verified ACGCET page.
   */
  if (item.unavailable) {
    return (
      <div className="ugc-item ugc-item--unavailable">
        <span
          className="ugc-item-icon"
          aria-hidden="true"
        >
          •
        </span>

        <span className="ugc-item-content">
          <span className="ugc-item-label">
            {item.label}
          </span>
        </span>

        <span className="ugc-status-pill">
          To be updated
        </span>
      </div>
    );
  }

  /*
   * Normal linked item.
   */
  return (
    <a
      className="ugc-item ugc-item--link"
      href={item.href}
      {...(item.external
        ? {
            target: "_blank",
            rel: "noopener noreferrer",
          }
        : {})}
    >
      <span className="ugc-item-icon">
        {iconForItem(item)}
      </span>

      <span className="ugc-item-content">
        <span className="ugc-item-label">
          {item.label}
        </span>

        {item.note && (
          <span className="ugc-item-note">
            {item.note}
          </span>
        )}
      </span>

      <span
        className="ugc-item-arrow"
        aria-hidden="true"
      >
        <ChevronRightIcon />
      </span>
    </a>
  );
}

/* ---------- page ---------- */

function UGCPublicSelfDisclosure() {
  const [openSections, setOpenSections] = useState(
    () => new Set()
  );

  const [query, setQuery] = useState("");

  const trimmedQuery = query.trim();
  const isSearching = trimmedQuery.length > 0;

  const visibleSections = useMemo(() => {
    const lowerQuery = trimmedQuery.toLowerCase();

    return sections
      .map((section) => {
        const { letter, heading } =
          splitSectionTitle(section.title);

        const headingMatches =
          isSearching &&
          heading.toLowerCase().includes(lowerQuery);

        const items =
          isSearching && !headingMatches
            ? filterItems(section.items, trimmedQuery)
            : section.items;

        return {
          ...section,
          letter,
          heading,
          items,
          matches:
            !isSearching ||
            headingMatches ||
            items.length > 0,
        };
      })
      .filter((section) => section.matches);
  }, [trimmedQuery, isSearching]);

  const isSectionOpen = (id) =>
    isSearching || openSections.has(id);

  const toggleSection = (id) => {
    if (isSearching) return;

    setOpenSections((current) => {
      const next = new Set(current);

      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }

      return next;
    });
  };

  const expandAll = () => {
    setOpenSections(
      new Set(sections.map((section) => section.id))
    );
  };

  const collapseAll = () => {
    setOpenSections(new Set());
  };

  const handleJump = (id) => {
    setOpenSections((current) => {
      const next = new Set(current);
      next.add(id);
      return next;
    });
  };

  return (
    <main className="ugc-page">
      <div id="ugc-top" className="ugc-container">

        <nav
          className="ugc-breadcrumb"
          aria-label="Breadcrumb"
        >
          <a href="/">Home</a>

          <span aria-hidden="true">/</span>

          <span aria-current="page">
            UGC Public Self-Disclosure
          </span>
        </nav>

        <header className="ugc-page-header">
          <p className="ugc-eyebrow">
            Institutional disclosure
          </p>

          <h1>
            UGC Public Self-Disclosure
          </h1>

          <p className="ugc-intro">
            Public disclosure information of Alagappa
            Chettiar Government College of Engineering
            and Technology, Karaikudi, published in line
            with UGC public self-disclosure norms.
          </p>
        </header>

        <div className="ugc-toolbar">

          <label
            className="ugc-search"
            htmlFor="ugc-search-input"
          >
            <SearchIcon />

            <input
              id="ugc-search-input"
              type="text"
              value={query}
              placeholder="Search disclosure items…"
              onChange={(e) =>
                setQuery(e.target.value)
              }
            />

            {query && (
              <button
                type="button"
                className="ugc-search-clear"
                onClick={() => setQuery("")}
                aria-label="Clear search"
              >
                ×
              </button>
            )}
          </label>

          <div className="ugc-toolbar-actions">
            <button
              type="button"
              onClick={expandAll}
              disabled={isSearching}
            >
              Expand all
            </button>

            <button
              type="button"
              onClick={collapseAll}
              disabled={isSearching}
            >
              Collapse all
            </button>
          </div>
        </div>

        <nav
          className="ugc-quicknav"
          aria-label="Jump to a disclosure section"
        >
          {sections.map((section) => {
            const { letter } =
              splitSectionTitle(section.title);

            return (
              <a
                key={section.id}
                href={`#${section.id}`}
                className="ugc-quicknav-chip"
                onClick={() =>
                  handleJump(section.id)
                }
              >
                {letter}
              </a>
            );
          })}
        </nav>

        <p
          className="ugc-visually-hidden"
          role="status"
          aria-live="polite"
        >
          {isSearching
            ? `${visibleSections.length} section${
                visibleSections.length === 1
                  ? ""
                  : "s"
              } match "${trimmedQuery}".`
            : ""}
        </p>

        <section
          className="ugc-disclosure-list"
          aria-label="UGC disclosure categories"
        >

          {isSearching &&
            visibleSections.length === 0 && (
              <p className="ugc-empty-state">
                No disclosure items match "
                {trimmedQuery}".
              </p>
            )}

          {visibleSections.map((section) => {
            const open = isSectionOpen(section.id);

            const panelId =
              `${section.id}-panel`;

            const triggerId =
              `${section.id}-trigger`;

            const count =
              countLeafItems(section.items);

            return (
              <article
                id={section.id}
                className={`ugc-accordion ${
                  open ? "is-open" : ""
                }`}
                key={section.id}
              >

                <h2 className="ugc-accordion-heading">
                  <button
                    type="button"
                    id={triggerId}
                    className="ugc-accordion-trigger"
                    aria-expanded={open}
                    aria-controls={panelId}
                    onClick={() =>
                      toggleSection(section.id)
                    }
                  >
                    <span
                      className="ugc-section-badge"
                      aria-hidden="true"
                    >
                      {section.letter}
                    </span>

                    <span className="ugc-accordion-title">
                      {section.heading}
                    </span>

                    <span className="ugc-count-pill">
                      {count}
                    </span>

                    <span
                      className="ugc-chevron"
                      aria-hidden="true"
                    >
                      <ChevronDownIcon />
                    </span>
                  </button>
                </h2>

                <div
                  id={panelId}
                  className="ugc-accordion-panel"
                  role="region"
                  aria-labelledby={triggerId}
                  hidden={!open}
                >
                  <div className="ugc-accordion-content">
                    {section.items.map((item) => (
                      <DisclosureItem
                        key={item.label}
                        item={item}
                      />
                    ))}
                  </div>
                </div>

              </article>
            );
          })}

        </section>

        {/* <p className="ugc-disclosure-note">
          Information marked "To be updated" has not
          yet been mapped to a verified existing ACGCET
          webpage in this disclosure directory.
        </p> */}

        <Backtotop />

      </div>
    </main>
  );
}

export default UGCPublicSelfDisclosure;
